import gql from 'graphql-tag';

export const REMOVE_PROMO = gql`
  mutation removePromo($id: ID!) {
    promocodes {
      delete(id: $id)
    }
  }
`;
